import React from "react";
import { useAuth } from "../context/AuthContext";

export default function Locked() {
  const { loginWithGoogle } = useAuth();

  return (
    <div className="min-h-screen bg-[#151515] text-white flex flex-col items-center justify-center px-4">
      <h1 className="text-4xl font-bold mb-4">Acces restricționat</h1>
      <p className="text-gray-400 mb-6 text-center max-w-md">
        Trebuie să te conectezi pentru a accesa tool-urile Metin2Tools.
      </p>

      <button
        onClick={loginWithGoogle}
        className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-semibold"
      >
        Login cu Google
      </button>
    </div>
  );
}
